import React from "react";
import {Fragment} from "react";
import Tab from "./Tab";

function App() {

    return (
        <Fragment>
            <Tab>
                <Tab.Item title="Hayvanlar">
                    <span className="text-xl font-bold mb-4 block">Hayvanlar: Doğanın Çeşitliliği ve Önemi</span>
                    Hayvanlar, dünyadaki doğal yaşamın vazgeçilmez bir parçasıdır. Çeşitlilikleri ve etkileyici
                    özellikleriyle hayvanlar, gezegenimizin zenginliğini ve karmaşıklığını yansıtır. Bu makalede,
                    hayvanların genel özelliklerini, çeşitliliklerini ve doğadaki rolünü keşfedeceğiz.

                    <span className="font-bold block mt-3 my-1.5">Biyolojik Çeşitlilik:</span>
                    Hayvanlar, dünyada büyük bir biyolojik çeşitlilik gösterir. Denizlerde yaşayan balıklar,
                    okyanuslarda yüzen balinalar, hava sahasında uçan kuşlar, ormanlarda dolaşan memeliler ve böcekler
                    gibi küçük canlılar, sadece bazı örneklerdir. Hayvanlar, farklı türler, cinsler, aileler ve takımlar
                    içinde sınıflandırılırlar ve her biri benzersiz özelliklere sahiptir.

                    <span className="font-bold block mt-3 my-1.5">Ekosistemlerin Dengeleyicileri:</span>
                    Hayvanlar, doğal ekosistemlerin işlevlerini ve dengeyi sürdürmede önemli bir rol oynarlar. Besin
                    zincirlerinin parçası olarak, bazı hayvanlar diğerlerini avlar ve bu sayede besin döngüsünü
                    sürdürürler. Aynı zamanda bitkilerin tozlaşmasında ve tohumların yayılmasında da kritik bir rol
                    oynarlar. Bu şekilde, hayvanlar ekosistemlerin dengesini sağlar ve çeşitliliği destekler.

                    <span className="font-bold block mt-3 my-1.5">İnsanlara Sağladıkları Faydalar:</span>
                    Hayvanlar, insanlar için birçok fayda sağlar. Tarım ve hayvancılık sektörü, hayvanların gıda
                    kaynakları olarak kullanılmasını içerir. Süt, et, yumurta, balık ve diğer hayvansal ürünler,
                    insanların beslenme ihtiyaçlarını karşılamada önemli bir rol oynar. Ayrıca, hayvanlar, giyim,
                    ilaçlar, deri, yün ve diğer malzemelerin elde edilmesinde de kullanılır.

                    <span className="font-bold block mt-3 my-1.5">Bilimsel Araştırmalar:</span>
                    Hayvanlar, bilimsel araştırmalar için değerli bir kaynaktır. Biyomedikal araştırmalar, ilaç
                    testleri, genetik çalışmalar, davranışsal gözlemler ve evrimsel çalışmalar, hayvanları içerir.
                    Hayvanların benzersiz fizyolojik özellikleri ve davranışları, insanların kendi türü ve diğer
                    organizmalar hakkında daha fazla bilgi edinmesine yardımcı olur.

                    <span className="font-bold block mt-3 my-1.5">Estetik Değer ve Doğal Yaşamın Zenginliği:</span>
                    Hayvanlar, doğanın güzelliklerini ve çeşitliliğini ortaya çıkarır. Renkli kuşlar, egzotik balıklar,
                    zarif filler, zürafalar ve diğer hayvanlar, estetik bir değer ve keyif sunar. Doğal yaşamın
                    zenginliği, insanların doğayla bağlantı kurmasına ve doğa sevgisini geliştirmesine yardımcı
                    olur.</Tab.Item>
                <Tab.Item title="İnsanlar">
                    <span className="text-xl font-bold mb-4 block"> İnsanlar: Dünyadaki En Karmaşık Varlıklar</span>
                    İnsanlar, Dünya'nın en özel varlıklarıdır. Yüzyıllardır merak uyandıran, araştırılan ve anlaşılmaya
                    çalışılan insanlar, akıl ve zeka ile donatılmış canlılardır. İnsanlar, diğer canlı türlerinden
                    farklı olarak, kompleks düşünme yeteneği, yaratıcılık, dil kullanımı, duygusal zeka ve karmaşık
                    sosyal ilişkiler kurma yeteneğiyle tanınırlar. Bu makalede, insanların özellikleri, becerileri ve
                    potansiyelleri üzerinde durulacak.

                    <span className="text-xl font-bold mb-4 block">İnsanın Evrimi:</span>
                    İnsanların tür olarak evrimi, yaklaşık 200.000 yıl öncesine dayanır. İnsanlar, Afrika'da Homo
                    sapiens olarak bilinen türün ortaya çıkmasıyla evrimleşti. İnsanın evrimi, büyük beyin kapasitesi,
                    dikey duruş, el becerisi ve karmaşık sosyal yapı gibi özelliklerin ortaya çıkmasıyla karakterizedir.
                    Bu evrimsel süreç, insanları dünya üzerinde diğer türlerden ayrılan benzersiz canlılar haline
                    getirdi.

                    <span className="text-xl font-bold mb-4 block">Zeka ve Potansiyel:</span>
                    İnsanların en dikkat çekici özelliği, yüksek zeka düzeyi ve potansiyelleridir. İnsanlar, soyut
                    düşünebilme, problem çözme, öğrenme yeteneği, dil geliştirme ve iletişim kurma yetenekleriyle diğer
                    canlılardan ayrılırlar. İnsanların zekası, onlara teknolojiyi keşfetme, bilim ve sanat alanında
                    ilerleme kaydetme ve karmaşık toplumları kurma becerisi vermiştir. İnsanlar, potansiyellerini
                    gerçekleştirme ve kendilerini sürekli olarak geliştirme yeteneğiyle tanınır.

                    <span className="text-xl font-bold mb-4 block">Duygusal Zeka:</span>
                    İnsanlar, sadece zeka açısından değil, aynı zamanda duygusal zeka açısından da öne çıkarlar.
                    Duygusal zeka, duyguları tanıma, anlama ve yönetme yeteneğidir. İnsanlar, başkalarının duygularını
                    okuyabilme, empati kurabilme ve ilişkileri yönetebilme becerisine sahiptirler. Bu özellik,
                    insanların sosyal bağlantılar kurmasına, işbirliği yapmasına ve toplum içinde uyumlu bir şekilde
                    yaşamasına yardımcı olur.

                    <span className="text-xl font-bold mb-4 block">Sosyal İlişkiler:</span>
                    İnsanlar, karmaşık sosyal ilişkiler kurma ve sürdürme yeteneğiyle tanınırlar. Aile, arkadaşlık,
                    romantik ilişkiler ve işbirliği gibi çeşitli sosyal bağlar geliştirebilirler. İnsanlar, iletişim
                    araçlarını kullanarak fikirleri paylaşabilir, kültürel normları oluşturabilir ve toplum içinde
                    roller üstlenebilirler. Sosyal ilişkiler, insanların yaşam kalitesini etkileyen önemli bir
                    faktördür.</Tab.Item>
                <Tab.Item title="Bitkiler">
                    <span className="text-xl font-bold mb-4 block">Bitkiler: Doğanın Canlı Mirası</span>
                    Bitkiler, dünyadaki yaşamın temel yapı taşlarından biridir. Hem doğal ekosistemlerde hem de
                    insanların yaşadığı alanlarda büyük bir çeşitlilik gösteren bitkiler, gezegenimiz için hayati öneme
                    sahiptir. Bu makalede, bitkilerin genel özelliklerini, önemini ve çeşitliliğini keşfedeceğiz.

                    <span className="font-bold block mt-3 my-1.5">Fiziksel Özellikler:</span>
                    Bitkiler, fotosentez yapabilen ve enerjiyi güneşten alabilen canlılardır. Genellikle kök, gövde ve
                    yapraklar gibi yapıları vardır. Kökler, bitkilerin toprağa bağlanmasını ve su ve besinleri emmeyi
                    sağlar. Gövde, bitkinin taşıyıcı yapısıdır ve genellikle dik durmasını sağlar. Yapraklar, fotosentez
                    süreci için güneş ışığını yakalar ve bitkiye enerji sağlar.

                    <span className="font-bold block mt-3 my-1.5">Fotosentez ve Oksijen Üretimi:</span>
                    Bitkiler, fotosentez yoluyla enerji üretirler. Güneş ışığı, bitkilerin yapraklarındaki klorofil
                    pigmentleri tarafından yakalanır ve bu enerjiyi kullanarak karbondioksiti parçalar ve oksijen
                    üretirler. Fotosentez süreci, atmosferdeki oksijenin üretilmesinde büyük bir rol oynar ve dünya
                    üzerindeki tüm canlıların hayatta kalmasını sağlar.

                    <span className="font-bold block mt-3 my-1.5">Biyolojik Çeşitlilik ve Ekosistemlerdeki Rolü:</span>
                    Bitkiler, dünyadaki biyolojik çeşitliliğin önemli bir parçasıdır. Ormanlar, çayırlar, çöller, sulak
                    alanlar ve dağlık bölgeler gibi farklı ekosistemlerde farklı bitki türleri bulunur. Bu bitkiler,
                    habitatlarını korur, toprak erozyonunu önler, su döngüsüne katkıda bulunur ve çeşitli hayvan
                    türlerine barınak ve besin kaynağı sağlar.

                    <span className="font-bold block mt-3 my-1.5">İnsanlar İçin Önemi:</span>
                    Bitkiler, insanlar için hayati öneme sahiptir. Gıda kaynakları olarak bitkiler, insanların
                    beslenmesini sağlar. Sebze, meyve, tahıl, baklagiller ve yağlı tohumlar gibi bitkisel ürünler,
                    insanların sağlıklı bir diyet sürdürmesine yardımcı olur. Ayrıca, bitkilerin lif, vitamin ve
                    mineraller açısından zengin olması da sağlık açısından büyük bir önem taşır.

                    <span className="font-bold block mt-3 my-1.5">Ekonomi ve Endüstri:</span>
                    Bitkiler, ekonomik açıdan da büyük bir değere sahiptir. Tarım sektörü, bitkilerin yetiştirilmesi ve
                    tarımsal ürünlerin işlenmesi yoluyla büyük bir ekonomik faaliyet alanıdır. Tarım, gıda üretiminin
                    yanı sıra ilaç, tekstil, yakıt ve diğer endüstriler için hammadde sağlar. Ayrıca, bitkilerin
                    çiçeklerinden elde edilen uçucu yağlar, kozmetik ve parfüm endüstrisinde kullanılır.</Tab.Item>
            </Tab>
        </Fragment>
    );
}

export default App;